// extracted by mini-css-extract-plugin
export var bodySections = "_c1-8";
export var gray = "_c1-7";
export var green = "_c1-4";
export var iconContainer = "_c1-9";
export var iconWidgetContainer = "_c1-1";
export var phoneIcon = "_c1-2";
export var red = "_c1-5";
export var statusDot = "_c1-3";
export var widgetContainer = "_c1-0";
export var yellow = "_c1-6";